import InferenceBatchClient from "@/clients/duallo/InferenceBatchClient";

class InferenceBatchService {
    async getByScanId(scanId) {
        return await InferenceBatchClient.getByScanId(scanId);
    }

    async getLatest(scanId) {
        return await InferenceBatchClient.getLatest(scanId);
    }
}

export default new InferenceBatchService();
